export type { IconProps } from "@radix-ui/react-icons/dist/types";

export * from "./icons/AlignObjectsIcons";
export * from "./icons/ArrowAngledIcon";
export * from "./icons/ArrowCurvedIcon";
export * from "./icons/ArrowsTopLeftBottomRightIcon";
export * from "./icons/ArrowStraightIcon";
export * from "./icons/BorderCenterIcon";
export * from "./icons/BorderInsideIcon";
export * from "./icons/BorderOutsideIcon";
export * from "./icons/BranchIcon";
export * from "./icons/ComponentIcon";
export * from "./icons/InstanceIcon";
export * from "./icons/ChatBubbleWithDotsIcon";
export * from "./icons/Cross3Icon";
export * from "./icons/DropdownChevronIcon";
export * from "./icons/FillIcon";
export * from "./icons/FlagIcon";
export * from "./icons/FlipHorizontalIcon";
export * from "./icons/FlipVerticalIcon";
export * from "./icons/FolderIcon";
export * from "./icons/GeometricPatternIcon";
export * from "./icons/HammerIcon";
export * from "./icons/HandIcon2";
export * from "./icons/InsertBlockIcon";
export * from "./icons/LineIcon";
export * from "./icons/MapPinIcon";
export * from "./icons/MarkdownIcon";
export * from "./icons/NoyaIcon";
export * from "./icons/PaperclipIcon";
export * from "./icons/PenIcon";
export * from "./icons/PointModeIcon";
export * from "./icons/PolygonIcon";
export * from "./icons/ReactLogoIcon";
export * from "./icons/SidebarIcon";
export * from "./icons/SignInIcon";
export * from "./icons/SparkleIcon";
export * from "./icons/StickyNoteIcon";
export * from "./icons/StrokeAndFillIcon";
export * from "./icons/StrokeLargeIcon";
export * from "./icons/StrokeMediumIcon";
export * from "./icons/StrokeSmallIcon";
export * from "./icons/TextVerticalMiddleIcon";
export * from "./icons/WebpageIcon";

// All icons should be imported from 'noya-icons'. We don't allow
// importing radix-ui icons directly outside of this package.
//
// eslint-disable-next-line no-restricted-imports
export * from "@radix-ui/react-icons";
